import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import Header from "../Header";
import Progress from "../../general/include/Progress";
import AppContext from "../../../contexts/AppContext";
import { register, getUserData } from "../../../services/user";
import RegisterTab from "./RegisterTab";
import PropTypes from "prop-types";
import { withRouter } from "react-router";
export class WriterForm extends Component {
    // static propTypes = {
    //     match: PropTypes.object.isRequired,
    //     location: PropTypes.object.isRequired,
    //     history: PropTypes.object.isRequired
    // };
    state = {
        loading: false,
    };

    constructor(props) {
        super(props);
        this.state = {
            item: {
                type: "writer",
                email: "",
                hasEmail: false,
                hasName: false,
                externalUserId: "",
                first_name: "",
                last_name: "",
                send_free_email: true,

            },
            errors: {},
        };
        const nextRoute = new URLSearchParams(window.location.search);
        if(nextRoute.get('tab') == 'writer'){
            let subscriber_email = localStorage.getItem("subscriber_user_email");
            let new_subscriber = localStorage.getItem("new_subscriber");
            this.state.item.email = new_subscriber ? new_subscriber : (subscriber_email !== null || subscriber_email !== undefined ? subscriber_email : '');
        }
    }

    toggleChange = () => {
        this.setState({
            send_free_email: !this.state.send_free_email,
        });
      }

    toggleWregister = () => {
        this.props.toggleWregister();
    }

    onChange = field => {
        let temp = this.state.item;
        temp[field.target.name] = field.target.value;

        let error = this.state.errors;
        error[field.target.name] = null;

        this.setState({ item: temp, errors: error });
        if(field.target.name == 'send_free_email'){
            this.state.item.send_free_email = ! this.state.item.send_free_email;
        }
    };
    submitRegister = e => {
        e.preventDefault();
        this.setState({ loading: true });
        register(this.state.item)
            .then(res => {
                this.setState({ loading: false });
                localStorage.setItem("auth_token", res.meta.token);
                localStorage.setItem("alerts", null);
                localStorage.setItem("welcome", null);
                localStorage.setItem("user_email", res.data.email);
                localStorage.setItem("user_steps", "writing-jobs");
                localStorage.setItem("user", JSON.stringify(res.data));
                localStorage.removeItem("new_subscriber");
                if (res.meta.token) {
                    //window.location = "/pw/" + res.data.url;
                    window.location = "/process/writingjobs";
                }
            })
            .catch(error => {
                console.log(error);
                this.setState({ loading: false });
                switch (error.response.status) {
                    case 422:
                        this.setState({
                            errors: error.response.data.error
                        });
                        break;
                    default:
                        this.context.state.handelError(error);
                        break;
                }
            });
    };

    componentDidMount() {

        this.context.state.updateMetaData('register');

        // let locationPath = this.props.location.pathname.split("-i-");
        let locationPath = this.props.localtionPath;
        // let locationPath = window.location.pathname;
        this.nameInput.focus();

        if (locationPath.length == 2) {
            let externalUserId = locationPath[1];

            let temp = this.state.item;
            temp['externalUserId'] = locationPath[1];
            this.setState({ item: temp });

            let data = { 'externalUser': this.state.item.externalUserId };

            getUserData(data)
                .then(res => {
                    let temp = this.state.item;
                    temp['first_name'] = res.data.first_name;
                    temp['last_name'] = res.data.last_name;
                    temp['hasName'] = true;
                    if (res.data.email !== null) {
                        temp['email'] = res.data.email;
                        temp['hasEmail'] = true;
                    }
                    this.setState({ item: temp });
                })
                .catch(error => {
                    this.setState({ loading: false });
                    switch (error.response.status) {
                        case 422:
                            this.setState({
                                errors: error.response.data.error
                            });
                            break;
                        default:
                            this.context.state.handelError(error);
                            break;
                    }
                });
        }

    }

    render() {
        //const { match, location, history } = this.props;
        return (
            <Fragment>

                <form onSubmit={this.submitRegister} method="POST">
                    <div className="form-group mb-0 row">
                        <div className="col-12 col-md-6 mb-3">
                            <input
                                ref={input => {
                                    this.nameInput = input;
                                }}
                                id="first_name"
                                type="text"
                                placeholder="Enter Your First Name..."
                                className={
                                    this.state.errors.first_name
                                        ? "is-invalid form-control  form-control-large"
                                        : " form-control  form-control-large"
                                }
                                name="first_name"
                                autoComplete="off"
                                onChange={this.onChange}
                                value={this.state.item.first_name}
                                disabled={this.state.item.hasName}
                            />
                            {this.state.errors.first_name ? (
                                <div className="invalid-feedback">
                                    {
                                        this.state.errors
                                            .first_name
                                    }
                                </div>
                            ) : null}
                        </div>
                        <div className="col-12 col-md-6 mb-3">
                            <input
                                id="last_name"
                                type="text"
                                placeholder="Enter Your Last Name..."
                                className={
                                    this.state.errors.last_name
                                        ? "is-invalid form-control  form-control-large"
                                        : " form-control  form-control-large"
                                }
                                name="last_name"
                                autoComplete="off"
                                onChange={this.onChange}
                                value={this.state.item.last_name}
                                disabled={this.state.item.hasName}
                            />
                            {this.state.errors.last_name ? (
                                <div className="invalid-feedback">
                                    {
                                        this.state.errors
                                            .last_name
                                    }
                                </div>
                            ) : null}
                        </div>
                    </div>
                    <div className="form-group mb-3">
                        <input
                            onChange={this.onChange}
                            type="text"
                            placeholder="Enter Your Email Address..."
                            className={
                                this.state.errors.email
                                    ? "is-invalid form-control  form-control-large"
                                    : " form-control  form-control-large"
                            }
                            name="email"
                            autoComplete="off"
                            id="email"
                            value={this.state.item.email}
                            disabled={this.state.item.hasEmail}
                        />
                        {this.state.errors.email ? (
                            <div className="invalid-feedback">
                                {this.state.errors.email}
                            </div>
                        ) : null}
                    </div>
                    <div className="form-group mb-3">
                        <input
                            onChange={this.onChange}
                            type="password"
                            placeholder="Create Your Password..."
                            name="password"
                            id="password"
                            className={
                                this.state.errors.password
                                    ? "is-invalid form-control  form-control-large"
                                    : " form-control  form-control-large"
                            }
                        />
                        {this.state.errors.password ? (
                            <div className="invalid-feedback">
                                {this.state.errors.password}
                            </div>
                        ) : null}
                    </div>
                    <div className="form-group">
                        <label className="custom-checkbox">
                            <div>
                             <input type="checkbox" name="send_free_email" defaultChecked={this.state.item.send_free_email} onChange={this.onChange} />
                            </div>
                            <span className="text-grey">Send me your free writing and finding jobs education emails.</span>
                        </label>
                    </div>
                    <button disabled={this.state.loading} className="bold btn form-control-large btn-lg btn-block btn-primary mt-4 mb-3 mx-auto py-3">
                        <i className={this.state.loading ? `mr-2 fas fa-spinner fa-spin` : ``}></i> {this.state.loading ? `Submitting...` : `Register`}
                    </button>
                    <small className="text-center text-grey d-block"><i className="fa fa-lock mr-2"></i>By providing us with your information you are consenting to the collection and use of your information in accordance with our <a href="https://www.iubenda.com/privacy-policy/72278847">Privacy Policy.</a></small>
                </form>

            </Fragment>
        );
    }
}

WriterForm.contextType = AppContext;
export default WriterForm;



// WEBPACK FOOTER //
// ./src/components/auth/register/WriterForm.js